define('views/modules/setting/business/blocks/custom-exercises/custom-exercises',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // collections
    'collections/calendar/session/custom-animations',
    // views
    'views/parts/info-section',
    'views/modules/calendar/animated-session/custom-exercises-manager/custom-exercises-manager-panel',
    // templates
    'text!templates/modules/setting/business/blocks/custom-exercises/custom-exercises.html'

], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // collections
    CCustomAnimations,
    // views
    VInfoSection,
    VCustomExercisesManagerPanel,
    // templates
    TCustomExercises
) {

    var VCustomExercises = Backbone.Epoxy.View.extend({
        template: TCustomExercises,

        regions: {
            count: '.count',
            datas: '.datas'
        },

        initialize: function(opt) {
            this.group = opt.group;
            this.url = opt.url;

            _.extend(this, {
                group: opt.group,
                url: opt.url,
                collection: new CCustomAnimations()
            });

            this.view = {
                info: new VInfoSection({
                    title: "Your custom exercises",
                    icon: "sl-icon-settings",
                    //help: "messages:helpbox-business-custom-exercises-view",
                    buttonBottom: {
                        text: "Manage my custom exercises",
                        context: this,
                        callback: this.onManageCustomExercises
                    },
                    content: this.template,
                }),
            };

            this.listenTo(this.collection, { 'sync': this.onCollectionSync });
        },

        render: function() {
            this.assign(this.view.info, this.$el) // must be first
                .applyBindings();

            this.generateZones();

            this.collection.getFirstPage();

            return this;
        },

        _renderCount: function() {
            this.zone.$count.html(this.collection.getTotal());
        },

        ////////////
        // events //
        ////////////

        onManageCustomExercises: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.manager || (view.manager = new VCustomExercisesManagerPanel({ group: this.group }));
            this.trigger('panel:stack', panel);
        },

        onCollectionSync: function(collection, options) {
            this._renderCount();
        },

    });

    return VCustomExercises;
});

